// import React from "react";

// const BackIcon = ({ 
//   size = 24, 
//   className = "", 
//   onClick, 
//   style = {},
//   fill = "#464646" 
// }) => {
//   return (
//     <svg 
//       width={size} 
//       height={size} 
//       viewBox="0 0 24 24" 
//       fill="none" 
//       xmlns="http://www.w3.org/2000/svg"
//       className={className}
//       onClick={onClick}
//       style={style}
//     >
//       <path
//         d="M20.6133 12.3867H3.38672C3.17314 12.3867 3 12.2136 3 12C3 11.7864 3.17314 11.6133 3.38672 11.6133H20.6133C20.8269 11.6133 21 11.7864 21 12C21 12.2136 20.8269 12.3867 20.6133 12.3867Z"
//         fill={fill}
//       />
//       <path
//         d="M7.64973 16.6055C7.55143 16.6055 7.4531 16.5682 7.37773 16.4936L3.11471 12.2749C3.04131 12.2022 3 12.1033 3 12C3 11.8967 3.04131 11.7978 3.11471 11.7251L7.37773 7.50637C7.52953 7.35615 7.77439 7.35741 7.92462 7.50925C8.07484 7.66106 8.07357 7.90592 7.92177 8.05614L3.93649 12L7.92173 15.9439C8.07354 16.0941 8.07484 16.339 7.92458 16.4908C7.849 16.5672 7.74936 16.6055 7.64973 16.6055Z"
//         fill={fill}
//       />
//     </svg>
//   );
// };

// export default BackIcon;
import React from "react";

const BackIcon = ({ 
  size = 24, 
  className = "", 
  onClick, 
  style = {},
  fill = "#464646" 
}) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={`back-icon ${className}`}
      onClick={onClick}
      style={style}
    >
      <g className="back-icon-group">
        <path
          d="M20.6133 12.3867H3.38672C3.17314 12.3867 3 12.2136 3 12C3 11.7864 3.17314 11.6133 3.38672 11.6133H20.6133C20.8269 11.6133 21 11.7864 21 12C21 12.2136 20.8269 12.3867 20.6133 12.3867Z"
          fill={fill}
        />
        <path
          d="M7.64973 16.6055C7.55143 16.6055 7.4531 16.5682 7.37773 16.4936L3.11471 12.2749C3.04131 12.2022 3 12.1033 3 12C3 11.8967 3.04131 11.7978 3.11471 11.7251L7.37773 7.50637C7.52953 7.35615 7.77439 7.35741 7.92462 7.50925C8.07484 7.66106 8.07357 7.90592 7.92177 8.05614L3.93649 12L7.92173 15.9439C8.07354 16.0941 8.07484 16.339 7.92458 16.4908C7.849 16.5672 7.74936 16.6055 7.64973 16.6055Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default BackIcon;